// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"89b4d1da","52":"5b61fcaf","472":"ef030969"}[chunkId] + ".chunk.js";
};